import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-33",
  "use": "icon-button_icon-33-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-33\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M21 3.532a1.246 1.246 0 011.25 1.25h0v13a1.246 1.246 0 01-1.25 1.25h0-9.75v2.857l-3.488-2.437a1.75 1.75 0 00-1.136-.42h0H3a1.246 1.246 0 01-1.25-1.25h0v-13A1.246 1.246 0 013 3.532h0z\" /><path d=\"M17 13.282H7M7 9.213h10\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol